import * as React from "react";
import Avatar from "@mui/material/Avatar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import PersonIcon from "@mui/icons-material/Person";
import Stack from "@mui/material/Stack";

import { blue } from "@mui/material/colors";

const CustomerSelectModal = (props) => {
  React.useEffect(() => {
    console.log(props);
  });

  const handleClose = () => {
    props.onClose();
  };

  const handleListItemClick = (value) => {
    props.onClose(value);
  };

  return (
    <Dialog onClose={handleClose} open={props.open}>
      <DialogTitle>{props.title}</DialogTitle>
      <List sx={{ pt: 0 }}>
        {props.list &&
          props.list.map((item) => (
            <ListItem disableGutters>
              <ListItemButton
                onClick={() => handleListItemClick(item)}
                key={item}
              >
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                    <PersonIcon />
                  </Avatar>
                </ListItemAvatar>
                <Stack direction="row">
                  <ListItemText
                    primary={
                      item.name + " " + item.phone + " " + item.cellphone
                    }
                  />
                </Stack>
              </ListItemButton>
            </ListItem>
          ))}
      </List>
    </Dialog>
  );
};

export default CustomerSelectModal;
